import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SidebarContextProvider } from "./store/sidebarContext";
import { LangContextProvider } from "./store/langContext";
import { ThemeContextProvider } from "./store/themeContext";
import { LoginContextProvider } from "./store/loginContext";


const root = ReactDOM.createRoot(document.getElementById("root")); // Create the root

root.render(
  <React.StrictMode>
    <LangContextProvider>
      <ThemeContextProvider>
        <LoginContextProvider>
          <SidebarContextProvider>
            <App />
          </SidebarContextProvider>
        </LoginContextProvider>
      </ThemeContextProvider>
    </LangContextProvider>
  </React.StrictMode>
);
